// Extraido de features/catalog/lib/menu-item-blueprint.ts: a mesma armadilha de
// contexto seguro atinge o cancelamento de assinatura, que nao tem nada a ver
// com catalogo. O nome publico foi mantido para nao mexer nos chamadores.

/**
 * Gera o id de variações, grupos e opções montados no cliente.
 *
 * `crypto.randomUUID` só existe em contexto seguro — HTTPS ou localhost.
 * Servido por HTTP em qualquer outro host (a máquina pela rede local, um
 * ambiente de teste), ele vem `undefined` e a chamada estourava dentro do
 * handler de clique: aplicar um modelo com variações, adicionar um tamanho ou
 * criar um grupo de escolhas simplesmente não fazia nada, sem erro na tela.
 *
 * `crypto.getRandomValues`, ao contrário, existe em qualquer contexto — daí o
 * fallback abaixo, que monta um UUID v4 equivalente.
 */
export function createClientId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  const bytes = new Uint8Array(16);

  if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
    crypto.getRandomValues(bytes);
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256);
    }
  }

  // Versão 4 e variante RFC 4122.
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');

  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20),
  ].join('-');
}
